import React from 'react';
import SuperAdminNavbar from '../../components/SuperAdminNav';
import DiscountManagement from '../../components/DiscountManagement';

const SuperAdminDiscounts = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary-50 to-accentwhite">
      <SuperAdminNavbar />
      <div className="container mx-auto px-4 py-8">
        <DiscountManagement />
      </div>
    </div>
  );
};

export default SuperAdminDiscounts;